import { render, staticRenderFns } from "./MyTournamentsAttend.vue?vue&type=template&id=12bd36f6&"
import script from "./MyTournamentsAttend.vue?vue&type=script&lang=js&"
export * from "./MyTournamentsAttend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports